// nurseries.component.ts
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NurseryService } from '../services/nursery.service';
import { StatesService } from 'app/services/states.service';
import { State } from 'app/models/State';
import { Nursery } from 'app/models/Nursery';

@Component({
  selector: 'app-nurseries',
  templateUrl: './nurseries.component.html',
  styleUrls: ['./nurseries.component.scss']
})
export class NurseriesComponent implements OnInit {
  nurseries: Nursery[] = [];
  states: State[] = [];
  searchKeyword: string = '';

  filter: any = {
    keyword: '',
    state: '',
    city: '',
    zip: '',
    packagingType: '',
    orderBy: 'name',
    range: 3500
  };

  constructor(
    private nurseryService: NurseryService,
    private statesService: StatesService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.searchKeyword = this.route.snapshot.queryParams['keyword'] || '';
    this.filter.keyword = this.searchKeyword;
    this.search();

    this.statesService.getStates().subscribe({
      next: (states) => this.states = states,
      error: (err) => console.error('Error fetching states:', err)
    });
  }

  onSubmitFilter(filterData: any) {
    this.searchKeyword = filterData.keyword;
    this.filter = { ...filterData };
    this.search();
  }

  onSortByChange(sortBy: string) {
    this.filter.orderBy = sortBy;
    this.searchKeyword = this.filter.keyword;
    this.search();
  }

  onResetFilter() {
    this.filter = {
      keyword: '',
      state: '',
      city: '',
      zip: '',
      packagingType: '',
      orderBy: 'name',
      range: 3500
    };
    this.searchKeyword = '';
    this.search();
  }

  search() {
    this.nurseryService.getNurseryData({
      keyword: this.filter.keyword,
      state: this.filter.state,
      city: this.filter.city,
      zip: this.filter.zip,
      packagingType: this.filter.packagingType,
    }).subscribe({
      next: (data: Nursery[]) => {
        const maxRange = this.filter.range;
        const filteredData = data.filter(n => n.distanceToMe == null || n.distanceToMe <= maxRange);

        switch (this.filter.orderBy) {
          case 'created_at':
            filteredData.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
            break;
          case 'name':
            filteredData.sort((a, b) => a.name.localeCompare(b.name));
            break;
          case 'name_desc':
            filteredData.sort((a, b) => b.name.localeCompare(a.name));
            break;
          case 'distance':
            filteredData.sort((a, b) => (a.distanceToMe || 0) - (b.distanceToMe || 0));
            break;
        }

        this.nurseries = filteredData;
      },
      error: (err) => console.error('Error fetching filtered data:', err)
    });
  }
}